import { createContext } from "react";
import orderBy from "lodash/orderBy";

const FORM_UI_STATE = Object.freeze({
  ADD_NEW_EMAIL: "ADD_NEW_EMAIL",
  SEND_OTP: "SEND_OTP",
  VERIFY_OTP: "VERIFY_OTP",
});

const PageConfig = {
  FORM_UI_STATE,
  FORM_STEPPER_STEPS: orderBy(
    [
      {
        state: FORM_UI_STATE.ADD_NEW_EMAIL,
        label: "settingPage.addNewEmailAddress",
        step: 0,
      },
      {
        state: FORM_UI_STATE.SEND_OTP,
        label: "settingPage.recieveVerificationCode",
        step: 1,
      },
      {
        state: FORM_UI_STATE.VERIFY_OTP,
        label: "settingPage.verification",
        step: 2,
      },
    ],
    ["step"],
    "asc"
  ),
  NO_OF_OTP_DIGITS: 6,
};

const initlaState = {
  formUIState: PageConfig.FORM_UI_STATE.SEND_OTP,
  setFormUIState: () => {},
  bypassTriggerOTP: false,
  setBypassTrigerOTP: () => {},
  token: "",
  setToken: () => {},
  retryTimeout: 0,
  setRetryTimeout: () => {},
  newEmailAddress: "",
  setNewEmailAddress: () => {},
};
export const PageContext = createContext(initlaState);

export default PageConfig;
